import { defineComponent as _defineComponent } from 'vue';
import Dropdown from 'primevue/dropdown';
import Sidebar from 'primevue/sidebar';
import SaveCancelButtons from '../../../Components/SaveCancelButtons.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LinkStation',
    props: ['visible'],
    emits: ['save', 'cancel', 'update:visible'],
    setup(__props, { expose, emit }) {
        expose();
        const save = () => {
            emit('update:visible', false);
        };
        const cancel = () => {
            emit('update:visible', false);
        };
        const __returned__ = { emit, save, cancel, get Dropdown() { return Dropdown; }, get Sidebar() { return Sidebar; }, SaveCancelButtons };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
